module.exports = {"name":"Name","yourMessage":"Your Message","messageSentTitle":"Your message was sent!","messageSentBody":"You can view all your messages at any time in <a href=\"/my/conversations/\">My Conversations</a>.","errors":{"isRequired":"This field is required.","dealerPhone":"Sorry, phone numbers are not permitted. To speak to the dealer, call","supportPhone":"Sorry, phone numbers are not permitted. To speak by phone, call 1stdibs at 1-877-721-3427."}}


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/constants/contactDealerCopy.json
// module id = 2278
// module chunks = 7